module.exports = __webpack_public_path__ + "img/1.1.ac27b128.png";